<template>
	<div class="position-relative app__form__field__checked">
		<!-- The PrimeVue control renders the associated native radio input. -->
		<!-- eslint-disable-next-line vuejs-accessibility/label-has-for -->
		<label class="d-flex align-items-center app__form__radio" :for="inputId">
			<prime-radio-button v-bind="$attrs" :input-id="inputId" />
			<span class="ms-3">
				<span v-if="label" v-html="label"></span>
				<slot v-else />
			</span>
		</label>
		<input-error :errors="error" />
	</div>
</template>

<script setup>
import { getCurrentInstance } from 'vue';
import PrimeRadioButton from 'primevue/radiobutton';
import InputError from './Error.vue';

defineProps({
	label: String,
	error: Object,
});

const inputId = `radio-${getCurrentInstance().uid}`;
</script>

<script>
export default {
	name: 'InputRadio',
	inheritAttrs: false,
};
</script>
